/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { type PairModel } from '@root/entities/pair'

import { markPairsArrived } from '../model/pair-arrivals'

import type { PairEventPayload } from '../atoms/reatom-pair-events'
import type { ArrayAtom } from '@reatom/framework'

export interface PairsUpdatePayload {
  pairs: Array<PairModel>
  updateType: PairEventPayload['updateType']
}

export const processPairEventsUpdateAction = action(
  (
    ctx,
    args: {
      currentPairsAtom: ArrayAtom<PairModel>
      update: PairsUpdatePayload
      maxCount: number
    },
  ) => {
    const { currentPairsAtom, update, maxCount } = args

    if (update.updateType === 'replace') {
      const before = ctx.get(currentPairsAtom)
      currentPairsAtom.toSpliced(ctx, 0, before.length, ...update.pairs)
    }

    if (update.updateType === 'append') {
      // The list is read again for every pool, because unshifting changes it.
      // Read once and a batch carrying the same pool twice got through the
      // check twice: the column showed one pool as two rows, with the figures
      // drifting apart as only one of them went on being updated.
      const seen = new Set(ctx.get(currentPairsAtom).map((it) => it.address))

      // This is the only place that knows a pool has just entered a list, and
      // the check above means it says so once per genuine arrival. Age cannot
      // stand in for it: a pool is created seconds before it reaches a feed,
      // and a paused column queues arrivals that then land together.
      const arrived: Array<string> = []

      for (const newPair of update.pairs) {
        if (seen.has(newPair.address)) {
          continue
        }
        seen.add(newPair.address)
        arrived.push(newPair.address)
        currentPairsAtom.unshift(ctx, newPair)
      }

      markPairsArrived(ctx, arrived)
    }

    if (update.updateType === 'update-existing') {
      // Handled inside reatom-pair
    }

    const after = ctx.get(currentPairsAtom)
    if (after.length > maxCount) {
      currentPairsAtom.toSpliced(ctx, maxCount, after.length)
    }
  },
)
